module.exports = __webpack_public_path__ + "static/media/explosion.14e74ca9.wav";